import React from 'react';

const ContractTypePage = React.lazy(() => import('pages/ContractType/ContractTypePage'));
const ContractTypeAddPage = React.lazy(() => import('pages/ContractType/ContractTypeAddPage'));

const CONTRACT_TYPE_PERMISSION = {
  VIEW: 'HR_CONTRACTTYPE_VIEW',
  ADD: 'HR_CONTRACTTYPE_ADD',
  EDIT: 'HR_CONTRACTTYPE_EDIT',
};

const contractType = [
  {
    path: '/contract-type',
    exact: true,
    name: 'Khai báo loại hợp đồng',
    function: CONTRACT_TYPE_PERMISSION.ADD,
    component: ContractTypePage,
  },
  {
    path: '/contract-type/add',
    exact: true,
    name: 'Thêm loại hợp đồng',
    function: CONTRACT_TYPE_PERMISSION.EDIT,
    component: ContractTypeAddPage,
  },
  {
    path: '/contract-type/edit/:contract_type_id',
    exact: true,
    name: 'Chỉnh sửa loại hợp đồng',
    function: CONTRACT_TYPE_PERMISSION.VIEW,
    component: ContractTypeAddPage,
  },
  {
    path: '/contract-type/detail/:contract_type_id',
    exact: true,
    name: 'Chi tiết loại hợp đồng',
    function: CONTRACT_TYPE_PERMISSION.VIEW,
    component: ContractTypeAddPage,
  },
];

export default contractType;
